import { Text } from '@wix/design-system';
import React, { FC, memo } from 'react';

import { attachmentsPreviewDataHooks } from './AttachmentsPreview.dataHooks';

type AttachmentPreviewDurationProps = Readonly<{
  name: string;
  duration: number; // ms
}>;

export const AttachmentPreviewDuration: FC<AttachmentPreviewDurationProps> = memo(({ duration, name }) => {
  const secondsDuration = Math.floor(duration / 1000);
  const hours = Math.floor(secondsDuration / 3600);
  const minutes = Math.floor((secondsDuration - hours * 3600) / 60);
  const seconds = secondsDuration - hours * 3600 - minutes * 60;

  const hoursString = hours < 10 ? `0${hours}` : `${hours}`;
  const minutesString = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const secondsString = seconds < 10 ? `0${seconds}` : `${seconds}`;

  return (
    <Text size="tiny" weight="thin" light dataHook={attachmentsPreviewDataHooks.duration({ name })}>
      {hours > 0 ? `${hoursString}:${minutesString}:${secondsString}` : `${minutesString}:${secondsString}`}
    </Text>
  );
});
